import type { Color } from 'chart.js';
import { styled } from 'styled-components';

import type { PluginLegendItem } from './index.ts';

const getColor = (color?: Color) => {
  if (color === undefined) return undefined;
  if (typeof color === 'string') return color;
  // eslint-disable-next-line no-console
  console.error('<ChartLegend /> not a "string" colors ');
  return undefined;
};

const ColorBox = styled.span`
  height: 12px;
  width: 12px;
  display: inline-block;
  flex-shrink: 0;
  border-radius: 3px;
`;

const List = styled.ul`
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  flex-flow: row wrap;
  gap: 16px;
  margin-bottom: 1em;
  line-height: 1em;
`;

const ListLi = styled.li`
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  gap: 6px;
`;

export const ChartLegend = ({ items }: { items: readonly PluginLegendItem[] }) =>
  items.length === 0 ? null : (
    <List>
      {items.map((item) => (
        <ListLi key={item.text} onClick={() => item.onClick()}>
          <ColorBox
            style={{
              background: getColor(item.fillStyle),
              borderColor: getColor(item.strokeStyle),
              borderWidth: item.lineWidth ? `${item.lineWidth}px` : undefined,
            }}
          />
          <span
            style={{
              textDecoration: item.hidden ? 'line-through' : '',
              color: getColor(item.fontColor),
            }}>
            {item.text}
          </span>
        </ListLi>
      ))}
    </List>
  );
